<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>
<div class="container blog-items">
  <app-blog-text-list *ngIf="isBlogSelected"></app-blog-text-list>
  <app-video-blog-list *ngIf="!isBlogSelected"></app-video-blog-list>
</div>
